export const TEST_ID = 'formulationEvidenceFields';

export const EVIDENCE_ROWS = 4;

export const MIXING_NOTE_ROWS = 2;
